/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */
import { assertSlots, ForwardRefComponent, mergeClasses } from '@fluentui/react-components';
import * as React from 'react';

import { useStyles } from "./DetailsPage.styles"
import { DetailsPageProps, DetailsPageSlots } from './DetailsPage.types';
import { useDetailsPageState_unstable } from "./useDetailsPage"

export const DetailsPage: ForwardRefComponent<DetailsPageProps> = React.forwardRef((props, ref) => {
  const state = useDetailsPageState_unstable(props, ref);

  const classes = useStyles();
  state.description.className = classes.description;
  state.heading.className = classes.heading;
  state.root.className = mergeClasses(classes.container, props.className);

  assertSlots<DetailsPageSlots>(state);
  return (
    <state.root>
      {/* TODO(nibeauli): this smells funny... feel like this should've been a slot */}
      <section className={classes.headerSection}>
        <state.heading />
        <state.description />
      </section>
      {state.root.children}
    </state.root>
  )
})
